import * as React from "react"
import { PeriodSelectorNav } from "src/shared/components/PeriodSelector/PeriodSelectorNav"

export const HomeApplicationHeaderMobile: React.FC = () => (
  <PeriodSelectorNav
    $variant="secondary-dark"
    navCSS="align-self: flex-start; margin-left: 11px;"
  />
)
